var map = {
	"./arabic.json": 522,
	"./bulgarian.json": 523,
	"./czech.json": 524,
	"./denmark.json": 525,
	"./english.json": 526,
	"./finnish.json": 527,
	"./greek.json": 528,
	"./indonesian.json": 529,
	"./malay.json": 530,
	"./norwegian.json": 531,
	"./romanian.json": 532,
	"./slovakia.json": 533,
	"./swedish.json": 534
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 216;


//////////////////
// WEBPACK FOOTER
// ./src/locales/miximo ^\.\/.*\.json$
// module id = 216
// module chunks = 0